import { VehicleStateEnum } from '../../../utils/enums';
import { normalize } from '../../../utils/functionHelper';

export const convertVehicleState = (state: string): VehicleStateEnum | undefined => {
  switch (state.toLowerCase()) {
    case 'perfektní':
      return VehicleStateEnum.perfect;
    case 'velmi dobrý':
      return VehicleStateEnum.veryGood;
    case 'dobrý':
      return VehicleStateEnum.good;
    case 'ukázkový':
      return VehicleStateEnum.showCar;
    default:
      return undefined;
  }
};

export const convertTransmissionType = (transType: string): string => {
  switch (transType.toLowerCase()) {
    case 'automatická':
      return 'AUTOMATIC';
    case 'manuální':
      return 'MANUAL';
    default:
      return transType;
  }
};

type MappableType = { label?: string | null; id: string | number };

export function createMapping<T extends MappableType>(items: Array<T>): Record<string, string> {
  return items.reduce((acc, item) => {
    if (!item.label) {
      return acc;
    }
    acc[normalize(item.label)] = String(item.id);
    return acc;
  }, {} as Record<string, string>);
}
